import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { solicitacaoService } from '../services/solicitacaoService';

/** Atalho na área de trabalho do parlamentar: fazer um pedido e ver quantos aguardam resposta. */
const CartaoFaleComEquipe: React.FC = () => {
  const navigate = useNavigate();
  const minhas = useQuery({ queryKey: ['solicitacoes', 'minhas'], queryFn: solicitacaoService.minhas });
  const aguardando = (minhas.data ?? []).filter((s) => s.status === 'ABERTA' || s.status === 'EM_ANALISE').length;

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-900/80">
      <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100">Fale com a equipe</h2>
      <p className="mt-1 text-base leading-7 text-slate-600 dark:text-slate-300">
        Precisa mudar algo ou tem uma dúvida? Faça um pedido aqui, sem precisar mandar mensagem.
      </p>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row">
        <button
          type="button"
          onClick={() => navigate('/dashboard/solicitacoes')}
          className="min-h-[52px] rounded-xl bg-blue-700 px-6 py-3 text-base font-semibold text-white transition hover:bg-blue-800"
        >
          Fazer um pedido ou tirar uma dúvida
        </button>
        <button
          type="button"
          onClick={() => navigate('/dashboard/solicitacoes')}
          className="min-h-[52px] rounded-xl border border-slate-300 bg-white px-6 py-3 text-base font-semibold text-slate-700 transition hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          Meus pedidos{aguardando > 0 ? ` (${aguardando} aguardando)` : ''}
        </button>
      </div>
    </section>
  );
};

export default CartaoFaleComEquipe;
